export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const SCROLL_IS_BOTTOM = 'SCROLL_IS_BOTTOM';
